import * as Popover from "@radix-ui/react-popover";
import { Check, ChevronDown } from "lucide-react";
import { useRef, useState } from "react";
import styles from "../multi-filter-dropdown/multi-filter-dropdown.module.css";

export type SingleSelectDropdownOption = {
  value: string;
  label: string;
};

export function SingleSelectDropdown({
  label,
  triggerLabel,
  options,
  selectedValue,
  onValueChange,
}: {
  label: string;
  triggerLabel: string;
  options: SingleSelectDropdownOption[];
  selectedValue: string;
  onValueChange: (value: string) => void;
}) {
  const [open, setOpen] = useState(false);
  const triggerRef = useRef<HTMLButtonElement>(null);
  return (
    <Popover.Root open={open} onOpenChange={setOpen}>
      <div className={styles.control}>
        <Popover.Trigger asChild>
          <button ref={triggerRef} type="button" className={styles.trigger} aria-label={label}>
            {triggerLabel}
            <ChevronDown className={styles.triggerIcon} aria-hidden="true" />
          </button>
        </Popover.Trigger>
      </div>
      <Popover.Portal>
        <Popover.Content
          side="bottom"
          align="start"
          sideOffset={6}
          className={styles.content}
          onCloseAutoFocus={(event) => {
            event.preventDefault();
            triggerRef.current?.focus();
          }}
        >
          <ul className={styles.list} role="listbox" aria-label={label} aria-multiselectable="false">
            {options.map((option) => {
              const selected = option.value === selectedValue;
              return (
                <li key={option.value}>
                  <button
                    type="button"
                    className={styles.option}
                    role="option"
                    aria-selected={selected}
                    onClick={() => {
                      onValueChange(option.value);
                      setOpen(false);
                    }}
                  >
                    <span className={styles.optionLabel}>{option.label}</span>
                    {selected && <Check className={styles.includeIcon} aria-hidden="true" />}
                  </button>
                </li>
              );
            })}
          </ul>
        </Popover.Content>
      </Popover.Portal>
    </Popover.Root>
  );
}
